import { render, staticRenderFns } from "./DemoInfiniteScroll.vue?vue&type=template&id=5abbfaec"
import script from "./DemoInfiniteScroll.vue?vue&type=script&lang=js"
export * from "./DemoInfiniteScroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports